import axios from 'axios'

export const getAgromonData = async (
  startDate:string, endDate: string, OwId: string,
) => {
  const ndviData = await axios.get(`https://api.agromonitoring.com/agro/1.0/image/search?start=${startDate}&end=${endDate}&polyid=${OwId}&appid=${process.env.REACT_APP_AGROMONITORING_APP_ID}&clouds_max=70`)

  return ndviData
}
